var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabBox relative"},[_vm._v(" "+_vm._s(_vm.title)),(_vm.num!=-1)?_c('span',{staticClass:"tab"},[_vm._v(_vm._s(_vm.num))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e96422c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dot.vue
// module id = 221
// module chunks = 0